function MovieCard(props) {
    const { movie } = props
    
    return (
        <div>
            <div className="movie-card">
                <img className="movie-image" src={movie.image} alt="movie cover art" />
            </div>
        </div>
    )
}

export default MovieCard